export const formatDate = (currentDate) => {
  const formattedDate = new Intl.DateTimeFormat("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(currentDate);

  return formattedDate;
};
export const formatToISO = (dateStr) => {
  if (!dateStr) {
    return new Date();
  }
  // Separar por día, mes y año
  const [day, month, year] = dateStr.split("/");

  // Crear objeto Date con formato YYYY-MM-DD
  const date = new Date(`${year}-${month}-${day}T04:09:44.533Z`);

  // Convertir a ISO string
  return date.toISOString();
};

export const handleConvertMothtoString = (numericMonth) => {
  let stringMonth = "";
  const listMoth = [
    { numericMonth: 1, stringMonth: "Enero" },
    { numericMonth: 2, stringMonth: "Febrero" },
    { numericMonth: 3, stringMonth: "Marzo" },
    { numericMonth: 4, stringMonth: "Abril" },
    { numericMonth: 5, stringMonth: "Mayo" },
    { numericMonth: 6, stringMonth: "Junio" },
    { numericMonth: 7, stringMonth: "Julio" },
    { numericMonth: 8, stringMonth: "Agosto" },
    { numericMonth: 9, stringMonth: "Septiembre" },
    { numericMonth: 10, stringMonth: "Octubre" },
    { numericMonth: 11, stringMonth: "Noviembre" },
    { numericMonth: 12, stringMonth: "Diciembre" },
  ];
  listMoth.map((month) => {
    if (month.numericMonth === numericMonth) {
      stringMonth = month.stringMonth;
    }
  });
  return stringMonth;
};

export const formatDateForInput = (dateString) => {
  if (!dateString) return "";

  // Si ya está en formato YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return dateString;

  // Intentar conversión desde DD/MM/YYYY
  const dateParts = dateString.split("/");
  // console.log(dateParts);

  if (dateParts.length === 3) {
    const [d, m, y] = dateParts;
    const year = y.padStart(4, "20");
    const month = m.padStart(2, "0");
    const day = d.padStart(2, "0");
    const isoDate = `${year}-${month}-${day}`;

    // Validar fecha resultante
    return isNaN(new Date(isoDate).getTime()) ? "" : isoDate;
  }

  return "";
};
